module.exports = __webpack_public_path__ + "static/media/qnyb.2138600b.png";